import { jsx as _jsx } from "react/jsx-runtime";
import { FormSelect, OptionGroup, } from '@common/ui/forms/select/select';
import { message } from '@common/i18n/message';
import { Option } from '@common/ui/forms/combobox/combobox';
import { useTrans } from '@common/i18n/use-trans';
export function TimezoneSelect({ name, size, timezones, label, ...selectProps }) {
    const { trans } = useTrans();
    return (_jsx(FormSelect, { selectionMode: "single", name: name, size: size, label: label, showSearchField: true, searchPlaceholder: trans(message('Search timezones')), ...selectProps, children: Object.entries(timezones).map(([sectionName, sectionItems]) => (_jsx(OptionGroup, { label: sectionName, children: sectionItems.map(timezone => (_jsx(Option, { value: timezone.value, children: timezone.text }, timezone.value))) }, sectionName))) }));
}
